export default __webpack_public_path__ + "static/media/FJ.b1dc366d.svg";